import actions from './dashboard_actions'
import state from './dashboard_state'
import getters from './dashboard_getters'
import mutations from './dashboard_mutations'

export default {
    name: 'dashboard',
    getters,
    mutations,
    state,
    actions,
    auth: {
        require: true
    },
    persistence: {
        type: 'localStorage',
        ignored_mutations: ['SET_CURRENT_DRAGGED_WIDGET']
    }
}
